import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=23299f3c&scoped=true&"
import script from "./Deposit.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Deposit.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=23299f3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23299f3c",
  null
  
)

export default component.exports